// Third-party imports
import $ from 'jquery';

// Local imports
import * as wv from '../../global/worldvision.js';

// global arg is expected to be the window object when run in a browser
export function initialize(global) {
    let params = wv.get_obj(global, 'url_params');
    if (!params.mot_code) {
        return;
    }
    injectMotCode(params.mot_code);
}

function injectMotCode(motCode) {
    let targetInput = $('input[name="properties[mot_code]"]');
    if(targetInput == null){
        targetInput = $('input[name="properties[_mot_code]"]');
    }
    targetInput.val(motCode);
}
